var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.isSM)?_c('span',{class:_vm.checkClass(_vm.statusName)},[_vm._v(_vm._s(_vm.statusName))]):_vm._e(),(_vm.isSM)?_c('small',{class:_vm.checkClass(_vm.statusName)},[_vm._v(_vm._s(_vm.statusName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }